import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, DropletIcon, FileBadgeIcon, PawPrintIcon, SmartphoneIcon, TrashIcon, TriangleAlertIcon, VolleyballIcon } from 'lucide-react';
import { quickLinks } from '../data/homepage';
const icons = {
  smartphone: SmartphoneIcon,
  ball: VolleyballIcon,
  alert: TriangleAlertIcon,
  trash: TrashIcon,
  pet: PawPrintIcon,
  permit: FileBadgeIcon,
  bell: BellIcon,
  water: DropletIcon
};
export function QuickAccess() {
  return <section aria-labelledby="services-rapides" className="relative z-20 mx-auto -mt-16 max-w-[1400px] px-5 lg:px-10" data-id="element-2710" data-mp="2iamknwxl7vz1">
      <div className="rounded-3xl bg-white px-6 py-7 shadow-[0_20px_55px_-15px_rgba(15,36,80,0.25)] ring-1 ring-ville-navy/5 lg:px-10" data-id="element-2711" data-mp="2n2w6p1vl0bw1">
        <h2 id="services-rapides" className="sr-only" data-id="element-2712" data-mp="2s31wsdm7dqc0">
          Services les plus demandés
        </h2>
        <ul className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-4 lg:grid-cols-8" data-id="element-2713" data-mp="2wy7ibbbp12zk">
          {quickLinks.map(link => {
          const Icon = icons[link.icon as keyof typeof icons];
          return <li key={link.label} data-id="element-2714" data-mp="3vxewyenoaqlb">
                <Link to={link.to ?? '/'} className="group flex flex-col items-center gap-3 rounded-2xl px-2 py-1 text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-2715" data-mp="3vw3wootfs0yy">
                  <span className="grid h-16 w-16 place-items-center rounded-full bg-ville-mist text-ville-blue transition-[transform,background-color,color] duration-150 ease-ville group-hover:-translate-y-1 group-hover:bg-ville-blue group-hover:text-white" data-id="element-2716" data-mp="nhc0l520goca">
                    <Icon className="h-7 w-7" aria-hidden="true" data-id="element-2717" data-mp="dpz7ka4h7s4o" />
                  </span>
                  <span className="text-sm font-bold leading-tight text-ville-navy" data-id="element-2718" data-mp="9p5lzneiapey">{link.label}</span>
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}